import React from 'react'

const CaseStudyCard = ({data:{category,heading,subHeading,img ,link}}) => {
  return (
    <div className='case__card'>
        <img className='case__img' alt='case__img' src={img}/>
        <div className='case__text'>
            <div className={`case__category ${category?.toLowerCase()}`}>{category}</div>
            <div className='case__heading'>{heading}</div>
            <div className='case__sub'>{subHeading}</div>
            <a href={link} target="_blank" rel="noopener noreferrer" >
            <div className='case__cta'>
              Read More 
              <img className='case__cta-arrow' src={require('../../assets/images/arrow-up-white.svg')} alt="arrow-up-white"/>
            </div>
            </a>
        </div>
    </div>
  )
}

export default CaseStudyCard